import React from 'react';

import Tooltip from '@mui/material/Tooltip';

const TooltipOnCursor = ({ title, children }) => {

    // Position stockée dans un ref (pas un state) pour éviter un re-render à chaque mouvement
    // de souris, qui pouvait interrompre les clics en cours sur l'enfant.
    const positionRef = React.useRef({ x: 0, y: 0 });
    const popperRef = React.useRef(null);
    const areaRef = React.useRef(null);

    const handleMouseMove = (event) => {
        positionRef.current = { x: event.clientX, y: event.clientY };
        if (popperRef.current != null) {
            popperRef.current.update();
        }
    };

    if (!title) {
        return (
            <>
                {children}
            </>
        );
    }

    return (
        <Tooltip
            title={title}
            placement="top"
            PopperProps={{
                popperRef,
                anchorEl: {
                    getBoundingClientRect: () => new DOMRect(
                        positionRef.current.x,
                        areaRef.current?.getBoundingClientRect().y ?? positionRef.current.y,
                        0,
                        0,
                    ),
                },
            }}
        >
            {React.cloneElement(children, {
                ref: areaRef,
                onMouseMove: handleMouseMove,
            })}
        </Tooltip>
    );
};

export default TooltipOnCursor;
